import { Link } from 'react-router-dom'

import logoUrl from '@/assets/vaagon-logo.svg'
import { cn } from '@/lib/cn'

type BrandMarkProps = {
  /** Softer wordmark (e.g. header when logged out). */
  subtle?: boolean
  className?: string
}

export function BrandMark({ subtle = false, className }: BrandMarkProps) {
  return (
    <Link
      to="/"
      aria-label="Vaagon"
      className={cn(
        'flex min-w-0 shrink-0 items-center text-left transition-opacity hover:opacity-90',
        className,
      )}
    >
      <img
        src={logoUrl}
        alt="Vaagon"
        className={cn('h-7 w-auto md:h-8', subtle && 'opacity-70')}
      />
    </Link>
  )
}
